import styled from "styled-components";

export const WrapWriting = styled.div`
  display: flex;
  width: 100%;
  height: 50vw;
  margin: 20px 0;
  background-color: white;
  border-radius: 5px;

`;
